module.exports = __webpack_public_path__ + "static/media/5f61296cd53d0.6ae794cf.jpg";